import Vue from "vue";
import VueRouter from "vue-router";
import WorkSpace from './WorkSpace.vue'
import HomePage from './HomePage.vue'
import PreviewPage from './PreviewPage.vue'
import LoginPage from './LoginPage.vue'
import UserManager from './UserManager.vue'
import SamplePage from './SamplePage.vue'
const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomePage
        },
        {
            path: '/SamplePage',
            name: 'SamplePage',
            component: SamplePage
        },
        {
            path: '/UserManager',
            name: 'UserManager',
            component: UserManager
        },
        {
            path: '/LoginPage',
            name: 'LoginPage',
            component: LoginPage
        },
        {
            path: '/WorkSpace/:id',
            name: 'WorkSpace',
            component: WorkSpace
        },
        {
            path: '/PreviewPage/:id',
            name: 'PreviewPage',
            component: PreviewPage
        }
    ]
})

export default router;